// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CVehicle_abstract } from './../abstract/SagaSchema/CVehicle_abstract';
export class CVehicle extends CVehicle_abstract {
  static formsProperties = {
    info: ['Make', 'Model', 'Color', 'Country'],
    description: ['Registration', 'Kind', 'Remarks']
  };
}
